<template>
    <div class="console-container" v-show="showConsole">
      <div class="console-title">
        Terminal
        <button class="clear-button" @click="$emit('clearConsole')">Limpar</button>
      </div>
      <div class="console-messages">
        <div v-for="(msg, index) in consoleMessages" :key="index" class="console-message">
            <span class="timestamp">[{{ msg.timestamp }}]</span> <span v-html="msg.message"></span>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: ['showConsole', 'consoleMessages'],

    watch: {
      consoleMessages() {
        this.$nextTick(() => {
          const container = this.$el.querySelector('.console-messages');
          if (container) container.scrollTop = container.scrollHeight;
        });
      }
    },


  }

  
  </script>
  
<style scoped>
    .console-container {
        display: flex; /* Define o container para usar display flex */
        background: #011627;
        color: white;
        height: 30%;
        flex-direction: column; /* Isso ajuda a controlar o layout interno */
        overflow: hidden; /* Oculta o overflow para garantir que nada saia deste container */
      }

      .console-title {
        background-color: #1a202c;
        color: #9b9b9b;
        padding: 5px;
        text-align: left;
        display: flex;
        justify-content: space-between; /* Botões alinhados aos lados */
        
    }

    .console-messages {
        overflow-y: auto; /* Garante a rolagem apenas verticalmente se necessário */
        white-space: pre-wrap; /* Para \n sem substituição */
        flex-grow: 1; /* Faz com que esse elemento preencha o espaço restante */
        max-height: 100%; /* Garante que o container respeite a altura máxima */
        font-size: 1.2rem; /* Fonte menor */
    }

    .console-item {
        padding: 2px 5px; /* Ajuste conforme necessário para o espaçamento interno */
        border-bottom: 1px solid #2a2f3a; /* Opcional: adicione uma linha divisória entre as mensagens */
        
    }
</style>